import { useSendAiFeedbackMutation } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/AiFeedbackRpc.hooks';
import { handleApolloErrors } from '../../../utils/errorUtils';
export const useSendAiFeedback = options => {
  const [sendAiFeedback, {
    loading,
    error,
    data
  }] = useSendAiFeedbackMutation(Object.assign({
    onError: err => handleApolloErrors({
      error: err,
      loggingTitle: 'learningCenter.interactiveEducation.errors.feedbackError'
    })
  }, options));
  return {
    sendAiFeedback,
    loading,
    error,
    data
  };
};